<template>
<div class="addresses-component">
  <div class="addresses-component__content static-container">
    <div class="addresses-component__list-card">
      <header class="addresses-component__list-header">
        <h3 class="addresses-component__list-header-title">Мои адреса</h3>
        <div class="flex-grow invisible"></div>
        <router-link :to="{ name: 'dashboard' }" class="addresses-component__list-header-link">
          <i class="fal fa-arrow-left mr-1"/> В личный кабинет
        </router-link>
      </header>

      <TransitionExpand>
        <AddressesList v-if="addresses instanceof Array" :addresses="addresses" />
        <Preloader v-else/>
      </TransitionExpand>
    </div>
    <transition name="opacity" mode="out-in">
      <ProfileItemDetailsModal v-if="showDetails"
                               @dismiss="$router.back()"
                               :key="action === 'edit' ? selectedAddress.id : 'create'"
                               class="addresses-component__details-modal"
      >
        <AddressDetails :address="action === 'edit' ? selectedAddress : null"
                        class="addresses-component__details-card"
        />
      </ProfileItemDetailsModal>
    </transition>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import withModals from '@/mixins/withModals';
import TransitionExpand from '@/components/AsyncTransitionExpand';
import InjectsSeo from "@/mixins/InjectsSeo";

export default {
  mixins: [withModals, InjectsSeo],

  props: {
    id: {
      required: false,
      type: String,
    },

    action: {
      required: true,
      type: String,
      validator: v => ['list', 'create', 'edit'].includes(v),
    }
  },

  metaInfo() {
    return {
      title: this.getFullPageTitle('Адреса доставки'),
    }
  },

  components: {
    TransitionExpand,
    Preloader: () => import('@/components/preloaders/Preloader'),
    AddressesList: () => import(/* webpackPreload: true */ '@/components/profile/addresses/List'),
    ProfileItemDetailsModal: () => import('@/components/profile/ItemDetailsModal'),
    AddressDetails: () => import('@/components/profile/addresses/Details'),
  },

  created() {
    this.$store.dispatch('savedAddresses/load', this.$store.state.auth.token);
  },

  computed: {
    ...mapState({
      addresses: state => state.savedAddresses.addresses,
    }),

    selectedAddress() {
      return this.addresses instanceof Array && this.addresses.find(a => a.id === this.id) || null;
    },

    showDetails() {
      return this.action === 'edit' && this.selectedAddress || this.action === 'create';
    },

    overlayModalActive() {
      return this.showDetails && !this.$store.getters['ui/isBreakpointActive']('lg');
    },
  },

  data() {
    return {
      modalDescriptors: [
        { isActive: 'overlayModalActive', id: this },
      ],
    };
  },
};
</script>

<style lang="less">
@import './common';
@layout-breakpoint-name: lg; @layout-breakpoint: theme('screens.lg');

@r: addresses-component;
@page-padding: theme('padding.2');
@card-margin: theme('margin.2');
.@{r} {
  padding: @page-padding;
  background: @page-background;
  &__content {
    @apply flex relative items-start;
  }
  &__list-card:extend(.profile__card) {
    margin: @card-margin;
  }
  &__list-header:extend(.profile__card-header) {}
  &__list-header-title:extend(.profile__card-header-title) {}
  &__list-header-link:extend(.profile__card-header-button) {}

  &__details-modal {
    @apply self-stretch;
    padding: @page-padding;
  }
  &__details-card:extend(.profile__card) {
    @apply relative; // So it overlaps the mask.
    min-height: 0; // So it doesn't overflow the container;
    margin: @card-margin;
  }
}

@screen @layout-breakpoint-name {
  .@{r} {
    &__details-modal {
      @apply p-0;
    }
    &__details-card {
      @apply sticky;
      top: calc(var(--header-height) + @card-margin + @page-padding);
      max-height: calc(100vh - var(--header-height) - var(--bottom-nav-bar-height) - 2 * (@card-margin + @page-padding));
    }
  }
}
</style>
